import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button, Icon } from '@h3/antd-vue';
let PageLoadFail = class PageLoadFail extends Vue {
    refresh() {
        this.$emit('refresh');
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], PageLoadFail.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], PageLoadFail.prototype, "text", void 0);
tslib_1.__decorate([
    Prop()
], PageLoadFail.prototype, "btnText", void 0);
PageLoadFail = tslib_1.__decorate([
    Component({
        name: 'page-load-fail',
        components: {
            AButton: Button,
            AIcon: Icon
        }
    })
], PageLoadFail);
export default PageLoadFail;
